module.exports = __webpack_public_path__ + "img/menu-cho-express-thumbnail.427ff45b.jpg";